<template>
  <div class="nebToggle"
    :class="{
      off: !value,
      on: value,
      disabled
    }"
  >
    <div class="nebToggle-toggle"
      @click="toggleValue"
    >
      <div class="nebToggle-toggle-housing">
        <div class="nebToggle-toggle-circle"></div>
      </div>
    </div>

    <div class="nebToggle-label"
      v-show="label"
    >
      <label>{{ label }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NebToggle',

  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    toggleValue () {
      if (this.disabled) { return }

      this.$emit('input', !this.value)
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../style.scss';

.nebToggle {
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  &-toggle {
    cursor: pointer;

    &-housing {
      height: 15px;
      width: 25px;
      box-sizing: border-box;
      overflow: hidden;
      border-radius: 7.5px;
      padding: 0 1px;
      transition: all 300ms;
      position: relative;
    }

    &-circle {
      height: 13px;
      width: 13px;
      box-sizing: border-box;
      overflow: hidden;
      background-color: $white;
      border-radius: 6.5px;
      position: absolute;
      top: 1px;
      bottom: 1px;
      transition: all 200ms;
    }
  }

  &-label {
    height: 25px;
    display: flex;
    align-items: center;
    padding-left: 7px;

    label {
      font-family: $defaultFont;
      font-size: 12px;
      color: $slate-grey;
    }
  }
}

.nebToggle.on {
  .nebToggle-toggle {
    &-housing {
      background-color: $tiffany-blue;
    }

    &-circle {
      left: 11px;
      right: 1px;
    }
  }
}

.nebToggle.off {
  .nebToggle-toggle {
    &-housing {
      background-color: $warm-grey;
    }

    &-circle {
      right: 11px;
      left: 1px;
    }
  }
}

.nebToggle.disabled {
  .nebToggle-toggle {
    opacity: 30%;
    cursor: not-allowed;
  }

  .nebToggle-label {
    label {
      color: $warm-grey;
    }
  }
}
</style>
